import { getStoreDefinition } from '@/composables/StoreDefinition'
import { DatabaseView } from '@/enums/DatabaseView'
import { SqlComparison } from '@/enums/SqlComparison'
import { SqlOperator } from '@/enums/SqlOperator'
import { TableStoreOptions } from '@/enums/TableStoreOptions'
import type { IPeopleStore } from '@/interfaces/api/IPeopleStore'
import { defineStore } from 'pinia'

let _store: IPeopleStore

export const usePeoplePickerStore = () => {
  if (_store) {
    return _store
  }
  const option = TableStoreOptions.PeoplePicker
  const useStore = defineStore(option.id, getStoreDefinition(option))
  _store = useStore() as unknown as IPeopleStore
  _extend(_store)
  return _store
}

const _extend = (store: IPeopleStore) => {
  // Override the default table with a view.
  store.useView(DatabaseView.PeopleWithStatus)
  store.itemsPerPage = 5
  store.itemQuery = {
    where: [
      {
        field: 'inactive',
        comparison: SqlComparison.Equal,
        value1: false,
        operator: SqlOperator.And
      },
      {
        field: 'respiratorRequired',
        comparison: SqlComparison.Equal,
        value1: true
      }
    ]
  }
}
